<template>
    <div class="wallet_save">
        <div class="top">
            <div class="title">{{ text('wallet_withdrawal.select_account') }}</div>
            <WalletList v-model:activeWallet="activeWallet" />
            <div class="input">
                <span>{{ text('wallet_withdrawal.amount') }}</span>
                <input type="text" v-model="amount" inputmode="numeric" pattern="[0-9\s]{13,19}" placeholder="0">
            </div>
            <template v-if="envName === 'stater'">
                <template v-if="amount > 0"> 
                    <div >
                        <button class="main_btn" @click="sbpModalActive = true">
                            <img height="24" src="@/assets/images/sbp_logo.svg" alt="sbp"  style="vertical-align: middle;padding-right: 8px;" /> 
                            <span style="vertical-align: middle;">СБП</span>
                        </button>  
                        <TextModal 
                            @closeModal="sbpModalActive = false" 
                            v-if="sbpModalActive"
                            title="" 
                            text="Вывод по СБП временно недоступен" 
                        />                       
                    </div>
                    <br />
                    <div>
                        <button class="main_btn" @click="cashModalActive = true" >
                            <img height="24" src="@/assets/images/cash.svg" alt="sbp" style="vertical-align: middle;padding-right: 8px;" /> 
                            <span style="vertical-align: middle;">Снятие наличных</span>
                        </button>        
                        <TextModal 
                            @closeModal="cashModalActive = false" 
                            v-if="cashModalActive"
                            title="" 
                            :text="cashModalText" 
                        />                               
                    </div>
                </template>
            </template>

            <template v-else>

                <div class="input" v-if="activeWallet?.currency_code === 'USDC'">
                    <span>{{ text('wallet_withdrawal.usdc_etc_address') }}</span>
                    <input type="text" v-model="address" inputmode="numeric">
                </div>
                <div class="input" v-else>
                    <span>{{ text('wallet_withdrawal.card') }}</span>
                    <input
                        type="tel"       
                        v-model="formattedCard"
                        @input="formatCard"
                        inputmode="numeric" 
                        pattern="[0-9\s]{13,19}" 
                        autocomplete="cc-number" 
                        maxlength="19" 
                        placeholder="xxxx xxxx xxxx xxxx" 
                        required>
                </div>    
            
            </template>
            <!-- <div class="error">{{ errorMessage }}</div>  -->
        </div>
        <Button 
            v-if="envName !== 'stater'"
            @btnClick="showModal()" 
            :title="text('wallet_withdrawal.withdrawal_btn')" 
            :disabled="withdrawalDisabled || !amount || (activeWalleta?.currency_code === 'USDC' && !address) || (activeWallet?.currency_code !== 'USDC' && !card) || activeWallet.balance < amount" 
        />
        <PayModal 
            :stage="modalStage"
            :errorMessage="errorMessage"
            :sucessMessage="text('wallet_withdrawal.success_message')"
            @enterPin="doWithdrawal" 
            @closeModal="closeModal()"             
            v-if="modalActive" 
            :pinCode="pinCode" 
        />

      
    </div>
</template>

<script>
import WalletList from '@/components/WalletList.vue'
import Button from '@/components/Button.vue'
import PayModal from '@/components/PayModal.vue'
import TextModal from '@/components/TextModal.vue'

const cashModalText = `
  <h2>Получение наличных в кассе РНКО «СТАТЕРА» (ООО)</h2>
  <p>Для получения наличных денежных средств необходимо лично обратиться в отделение РНКО «СТАТЕРА» (ООО) по адресу:</p>
  <address>
    384900, Республика Абхазия,<br>
    г. Сухум, ул. Лакоба, д. 34
  </address>
  <p>При обращении в кассу необходимо предоставить:</p>
  <ul>
    <li>Паспорт на имя получателя.</li>
    <li>Информацию для оформления заявки:
      <ul>
        <li>Фамилия, имя, отчество получателя;</li>
        <li>Сумма к получению;</li>
        <li>Номер квитанции.</li>
      </ul>
    </li>
  </ul>
  <p>Сотрудник кассы оформит заявку на основании предоставленных данных. После проверки документов будет осуществлена выдача наличных денежных средств.</p>
  <p><strong>Важно:</strong> паспортные данные должны совпадать с информацией, указанной в электронном кошельке.</p>
`;



export default {
    name: "WalletWithdrawal",
    components: {
        WalletList,
        Button,
        PayModal,
        TextModal,
    },
    data () {
        return {
            modalStage: 'enterPin',
            amount: '',
            card: '',
            address: '',
            pin: '',
            errorMessage: '',
            modalActive: false,
            withdrawalDisabled: false,
            activeWallet: null,
            sbpModalActive: false,
            cashModalActive: false,
            cashModalText: cashModalText,
        }
    },
    computed: {
        authToken () {
            return this.$store.state.authToken
        },
        formattedCard: {
            get() {
                return this.card.replace(/\s+/g, '').replace(/(\d{4})/g, '$1 ').trim();
            },
            set(value) {
                this.card = value.replace(/\s/g, '');
            }
        }        
    },    
    methods: {
        formatCard() {
            this.card = this.card.replace(/\D/g, '').substring(0, 16);
        },
        async showModal () {
            this.modalActive = true;
            this.modalStage = 'enterPin';
        },
        async doWithdrawal(pinCode) {
            // this.modalActive = false;
            // this.topUpDisabled = true;
            this.modalStage = 'wating';

            const withdrawalData = {
                "amount": this.amount,
                "currency_code": this.activeWallet?.currency_code,
                "pin": pinCode,
            }

            if (this.activeWallet?.currency_code !== 'USDC') {
                withdrawalData.pan = this.pan
            } else {
                withdrawalData.address = this.address
            }
            
            const { data } = await this.$http.post(
                '/v2/wallet/withdrawal',
                withdrawalData,
                {                    
                    "headers": {
                        "Authorization": "Token " + this.authToken
                    },
                    "validateStatus": status => (status >= 200 && status < 500)                    
                },
            );
            
            if (data.status === "error") {
                this.modalStage = 'failed';
                this.errorMessage = data.message
            } else {
                this.modalStage = 'success';
            } 
            /*
            this.topUpDisabled = false;
            
            console.log(data)
            console.log(data.status)
            if (data.status === "error") {
                this.errorMessage = data.message
            } else {
                this.modalActive = true
            } 
            */
        },
        closeModal () {
            this.modalActive = false;
        }
    }
}
</script>

<style>

</style>